import React, { useEffect, useState } from 'react';
import {JobContainerStyled} from "../../../styled/JobConnection";
import JobList from "./JobList";
import JobView from "./JobView";
import {useTheme} from "../Theme/ThemeContext";
import Button from "../Buttons/Button";
import { useDispatch } from 'react-redux';
import {setInfo} from "../../../redux/states";


const JobConnection = ({ data, handleCopy, getJob, getResume, chooseActStr, deleteJob, jobListRef, loadingJobs, multiApplyMode=false, selectedJobIds=[], onToggleJobSelect, maxSelectable=5, onStart, processingView, startPending=false, gmailGranted=false, gmailIsGmail=false, onDisconnectGmail, disconnectPending=false }) => {
    const {themeName} = useTheme();
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(null);

    const handleJobClick = (index) => {
        if (multiApplyMode) return; // disable details opening in multi-select mode
        setActiveIndex(prevIndex => prevIndex === index ? null : index);
    };

    const infoSetter = (string) => {
        dispatch(setInfo({state: true, message:string}))
    }


    // If jobs array changes (reload/replace) and previously selected index is now invalid,
    // clear the selection to avoid passing undefined to JobView.
    useEffect(() => {
        const len = Array.isArray(data) ? data.length : 0;
        if (activeIndex !== null && (activeIndex < 0 || activeIndex >= len)) {
            setActiveIndex(null);
        }
    }, [data, activeIndex]);

    // Ensure list is visible (especially on mobile) when entering multi-select mode
    useEffect(() => {
        if (multiApplyMode) {
            setActiveIndex(null);
        }
    }, [multiApplyMode]);

    const forceRight = Boolean(processingView);
    return (
        <JobContainerStyled theme={themeName} activeIndex={activeIndex} forceRight={forceRight} >

            <div className="jobList">
                <JobList
                    data={data}
                    jobClick={activeIndex}
                    onJobClick={handleJobClick}
                    jobListRef={jobListRef}
                    loadingJobs={loadingJobs}
                    multiApplyMode={multiApplyMode}
                    processingActive={Boolean(processingView)}
                    selectedJobIds={selectedJobIds}
                    onToggleJobSelect={onToggleJobSelect}
                    onBlockedSelection={(job) => infoSetter("You've already applied to this job. It can't be selected again.")}
                    maxSelectable={maxSelectable}
                    onStart={onStart}
                    startPending={startPending}
                    gmailGranted={gmailGranted}
                    gmailIsGmail={gmailIsGmail}
                    onDisconnectGmail={onDisconnectGmail}
                    disconnectPending={disconnectPending}
                />
            </div>

            <div className="jobView">
                {processingView ? (
                    processingView
                ) : multiApplyMode ? (
                    <>
                        <h3>Select up to {maxSelectable} jobs from the list to auto-apply, then click Start</h3>
                        <div style={{ marginTop: '0.75rem', width: '100%', maxWidth: 260 }}>
                            <Button
                                secondaryLight={true}
                                width="100%"
                                title={startPending ? 'Starting…' : 'Start'}
                                disabled={startPending}
                                clickHandle={(e) => {
                                    e?.preventDefault?.();
                                    if (!startPending && typeof onStart === 'function') onStart();
                                }}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        {activeIndex === null && (
                            <h3 onClick={()=> infoSetter("Jobs are displayed on the left side menu")}>Click on a Job to view here</h3>
                        )}
                        {activeIndex !== null && (
                            <JobView
                                setActiveIndex={setActiveIndex}
                                job={Array.isArray(data) ? data[activeIndex] : undefined}
                                handleCopy={handleCopy}
                                getJob={getJob}
                                getResume={getResume}
                                chooseActStr={chooseActStr}
                                deleteJob={deleteJob}
                            />
                        )}
                    </>
                )}
            </div>

        </JobContainerStyled>

    );

}

export default JobConnection;